module.exports = __webpack_public_path__ + "static/Redux-Integration-ca86c4b431737698647ca830ead4824a.png";